module.exports = __webpack_public_path__ + "assets/img/Yoobic-Landing-Page-+-Website-w960.b0e75f60.webp";